import { Box, Paper, SvgIcon, Typography } from "@mui/material"

import { ReactComponent as Doctor } from "static/svg/navigation/doctor.svg"
import useTranslation from "../../../hooks/use_translation"

const DoctorIcon = (props) => <SvgIcon component={Doctor} inheritViewBox {...props} />

const Success = ({ light }) => {
  const { anamnesis } = useTranslation()

  return (
    <Paper
      elevation={0}
      sx={{ p: 2.5, backgroundColor: "#ECFFEB", borderRadius: "10px", display: "flex" }}
    >
      <Box
        sx={{
          backgroundColor: "#6EBD53",
          color: "#6EBD53",
          borderRadius: "5px",
          minWidth: 30,
          height: 30,
          mr: 1.5,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <DoctorIcon sx={{ width: 15, height: 15 }} />
      </Box>

      <Box>
        <Typography sx={{ fontWeight: 700, color: "#6EBD53", mt: light ? 0.5 : 0 }}>
          {anamnesis?.card_success_title}
        </Typography>
        {!light && (
          <Typography variant="body2" sx={{ mt: 0.5 }}>
            {anamnesis?.card_success_subtitle}
          </Typography>
        )}
      </Box>
    </Paper>
  )
}

export default Success
